import clsx from "clsx";
import { useEffect, useState } from "react";
import { FrankenstoryState } from "types/FrankenstoryState";

export const Timer = (props: {
    showTimer: boolean;
    seconds?: number;
    state: FrankenstoryState;
    pauseSecondsRemaining?: number;
}) => {
    const { seconds, showTimer, state, pauseSecondsRemaining } = props;

    const [isDanger, setIsDanger] = useState(false);
    const [actualSeconds, setActualSeconds] = useState(pauseSecondsRemaining ?? seconds);

    useEffect(() => {
        setActualSeconds(pauseSecondsRemaining ?? seconds);
    }, [pauseSecondsRemaining, seconds]);

    useEffect(() => {
        if (actualSeconds != null) {
            setIsDanger(state !== "Prompting" && state !== "Awarding" && actualSeconds <= 15 && !pauseSecondsRemaining);
        }
    }, [actualSeconds, pauseSecondsRemaining, state]);

    return actualSeconds ? (
        <div className={clsx("timer animate", showTimer || pauseSecondsRemaining ? "opacity-100" : "opacity-0")}>
            <div
                className={clsx(
                    "bg-white text-dark rounded-pill py-1 fw-bold px-3 d-flex gap-2 align-items-center border justify-content-between",
                    isDanger ? "border-danger" : "border-primary",
                )}
                style={{
                    width:
                        actualSeconds && actualSeconds > 99
                            ? 98
                            : actualSeconds && actualSeconds > 9
                            ? 84
                            : actualSeconds != null && actualSeconds >= 0
                            ? 76
                            : 0,
                }}
            >
                <span>{actualSeconds}</span>

                <span
                    className={clsx(
                        "fas",
                        pauseSecondsRemaining ? "fa-pause" : "fa-clock",
                        isDanger ? "text-danger fa-beat" : "text-primary",
                    )}
                ></span>
            </div>
        </div>
    ) : null;
};
